export enum ETLCodes {
  Home,
  BackendError,
  BackendErrorDetailledMessage,
  NotAuthorized,
  UserNotAuthorizedMessage,
  RouteConfirmDialogTitle,
  Add,
  Save,
  SearchPlaceholder,
  SearchCriteriaPanel_AddCriteria,
  SearchCriteriaPanel_FilterRemoveCriteria,
  SearchCriteriaPanel_RemoveCriteria,
  SearchCriteriaPanel_Search,
  SearchCriteriaPanel_SearchModes_Between,
  SearchCriteriaPanel_SearchModes_Contains,
  SearchCriteriaPanel_SearchModes_EndWith,
  SearchCriteriaPanel_SearchModes_Equals,
  SearchCriteriaPanel_SearchModes_Greater,
  SearchCriteriaPanel_SearchModes_GreaterOrEquals,
  SearchCriteriaPanel_SearchModes_GreaterThan,
  SearchCriteriaPanel_SearchModes_Less,
  SearchCriteriaPanel_SearchModes_LessOrEquals,
  SearchCriteriaPanel_SearchModes_LessThan,
  SearchCriteriaPanel_SearchModes_NotContains,
  SearchCriteriaPanel_SearchModes_NotEquals,
  SearchCriteriaPanel_SearchModes_StartWith,
  SearchCriteriaPanel_SearchModes_undefined,
  SearchCriteriaPanel_Yes,
  SearchCriteriaPanel_No,
  Cancel,
  Copy,
  GoBack,
  Edit,
  Export,
  Import,
  View,
  FormDirtyCancelMessage,
  Delete,
  Confirm,
  No,
  Yes,
  GeneralNoData,
  ClickOnPictureToEdit,
  FormDirtyRouteChangeMessage,
  SaveSuccess,
  Error,
  DeletedSuccessfully,
  AreYouSureYouWantToDeleteThisItem,
  AreYouSure,
  ErrorMessage_Unauthorized_title,
  ErrorMessage_Unauthorized,
  DeleteError,
  TranslationCode,
  LanguageCode,
  Text,
  ErrorWhileImportingTranslations,
  Translations,
  TableCriterias,
  TableResults,
  GeneralLoading,
  Menu,
  UnFixMenuTooltip,
  FixMenuTooltip,
  QuickAccess,
  SelectorAvailable,
  ChooseXItems,
  UnChooseXItems,
  SelectorSelected,
  Logout,
  Administration,
  Users,
  UserList,
  NewUser,
  Details,
  FirstName,
  LastName,
  Login,
  Role,
  UserSaved,
  Required,
  Sites,
  Name,
  Country,
  City,
  SiteList,
  TooLong,
  GeneralInformations,
  Street,
  Number,
  Box,
  PostalCode,
  NewSite,
  TrainingTypes,
  TrainingTypesList,
  Internal,
  TrainingType,
  NewTrainingType,
  CreatedOn,
  UpdatedOn,
  Rooms,
  Capacity,
  Color,
  NewRoom,
  HasWindows,
  HasVideoProjector,
  IsMergeable,
  RoomList,
  Description,
  RowVersion,
  ConcurrencyErrorMessage,
  Refresh,
  AssociatedRoom,
  Employee,
  EmployeeList,
  SiteUri,
  ApaIdentifier,
  Functions,
  Profiles,
  NewEmployee,
  UserType,
  Site,
  Languages,
  IsMain,
  IsUsedForTraining,
  ImportTranslationFile,
  TranslationsImportSuccess,
  ContactPhones,
  ContactEmails,
  Gender,
  ProTimeIdentifier,
  CapacityAfterMerge,
  Address,
  Trainings,
  TrainingList,
  NewTraining,
  HourlyType,
  MainSite,
  OperatorType,
  IsBapa,
  Localisation,
  PlaningTypeQuantity,
  To,
  Period,
  Language,
  NumberOfSessions,
  DailyDurationDescription,
  LocationDescription,
  ContactsDescription,
  DateFromMustBeSmallerThanDateTo,
  DateTo,
  DateFrom,
  Planning,
  Contacts,
  ViaEmployees,
  Planification,
  Duration,
  Trainer,
  Search,
  LapsFormation,
  Room,
  Day,
  StartHour,
  EndHours,
  NextHour,
  NextEmployeeInRoom,
  PreviousHourEmployeeInRoom,
  InRoomReservationResults,
  Plan,
  VisioReservationResults,
  VisioSession,
  InRoomSession,
  The,
  NoSessionSelected,
  VisioUri,
  PlannedSessions,
  Visio,
  DeleteConfirmationMessage,
  Warning,
  Employees,
  TimingNotValidAnymoreError,
  MailTemplates,
  MailTemplatesList,
  Code,
  Subject,
  IsTranslated,
  NewMailTemplate,
  HasContent,
  Content,
  LapWarningTooltip,
  PreviousHourWarningToolTip,
  NextHourWarningTooltip,
  Participants,
  From,
  Newcomers,
  NationalRegistrationNumber,
  OriginCountry,
  AccompagnyingPerson,
  BirthDate,
  Identity,
  ContactDetails,
  SocialReport,
  LegalReportAndlanguages,
  ReportDate,
  AdmisibleTypes,
  DeliveryDate,
  Months,
  NewNewComer,
  PermitValidity,
  RightAndDutyFollowup,
  isOkLevel1,
  isOkLevel3,
  isOkLevel2,
  Operator,
  PlanningType,
  InterviewLanguages,
  SpokenLanguages,
  NewcomersList,
  EmployeePlanningEmployeePlaceHolder,
  NewSession,
  TrainingLanguages,
  Sharepoint,
  DataTranslations,
  EntityName,
  EntityId,
  SmsTemplatesList,
  SmsTemplates,
  NewSmsTemplate,
  CurrentlyPlanned,
  PlannedSessions_Hours,
  PlannedSessions_Sessions,
  NumberOfSessionsOrHours,
  DurationLongerThanHoursToAdd,
  IsFavorite,
  PlaningTypeQuantity_Sessions,
  PlaningTypeQuantity_Hours,
  Action,
  RoleAndRights,
  Hours,
  To_Hour,
  Assignments,
  CannotDeletePastSessions,
  Ok,
  Attendance,
  Tasks,
  SessionsAwaitingAttendance,
  OccursOn,
  AmountOfAttendants,
  LastUpdateDate,
  GeneratedConventionDate,
  Attendees,
  AvailablePlaces,
  DefinitiveSave,
  TimeSpanSmallerThanDuration,
  Protime,
  Appointments,
  Date,
  For,
  MeetingList,
  NewMeeting,
  Meeting,
  MeetingType,
  InterpreterRequired,
  IsUrgent,
  NewComer,
  Other,
  Contact,
  Clear,
  NewComerSelector,
  OpenNewComerSelector,
  PartnerTypesList,
  NewPartnerType,
  PartnerTypes,
  PartnersList,
  NewPartner,
  SearchContact,
  Person,
  Partners,
  NoBookingSelected,
  RoomBookings,
  Dashboard,
  PhoneCalls,
  ReminderPhoneCalls,
  PastSessions,
  FutureSessions,
  FutureMeetings,
  PastMeetings,
  Remark,
  NoRoomSelected,
  RoomOrEmploeeNotAvailable,
  CannotDeleteEntityIsLinked,
  UpdatedBy,
  DutyList,
  Duties,
  NewDuty,
  IsUnavailable,
  DutiesOfTheDay,
  IsDone,
  OpenInNewTab,
  MeetingTypes,
  MeetingTypesList,
  NewMeetingType,
  Phone,
  CellPhone,
  Email,
  Present,
  Function,
  FunctionList,
  NewFunction,
  History,
  ApaTrainingHistory,
  StartDate,
  EndDate,
  AvailabilityDate,
  Status,
  Result,
  NewAssignment,
  HourlyTypes,
  NewHourlyType,
  UseForVia,
  OnlyShowPersonnalMeetings,
  NoTrainings,
  Trainers,
  GenerateReport,
  OutlookSync,
  GenerationInProgress,
  Thematic,
  ThematicTypesList,
  NewThematicType,
  ThematicTypes,
  Organization,
  NewComerFiles,
  FileName,
  ShowError,
  UploadNewComerFile,
  Gsm,
  Tel,
  StatusDossier,
  Active,
  SendEmail,
  GoToNttrb,
  FormDirtyCancelTitle,
  FormDirtyUnsavedMessage,
  FormDirtyLeaveButton,
  FormDirtyCancelButton,
  FieldName,
  ImportSuccess,
  GetTemplate,
  AddParticipants,
  AddParticipant,
  EmployeeIsNotUser,
  WelcomeOffice,
  Associations,
  AttendanceToDo,
}
